
app.pagearticleController = app.pagearticleController || {};
app.pagearticleController.defaultAction = {
   
    /**
     * Initialisation de la fonction
     * @returns {undefined}
     */
    init : function () {
        this.tags();
    },

    tags : function () {
        var tags = $('.blk-categories .categories > div');
        var form = $('.blk-form form');

        tags.on('click', function () {
            var tag = $(this).data('cat');
            var color = $(this).data('color');
            var css;

            if ($(this).hasClass('active')) {
                css = 'color:' + color +'; border:1px solid '+ color +';';

                $(".tag-" + tag).remove();

                $(this).attr('style', css);
                $(this).removeClass('active');

            } else {
                var html = '<input type="hidden" name="cats[]" class="tag-'+ tag +'" value="'+ tag +'">';
                css = 'color:' + color +'; background:'+ color +'19; border:1px solid '+ color +'19;';

                $(this).attr('style', css);
                $('.blk-form form').append(html);

                $(this).addClass('active');
            }

            form.submit();
        });
    }
};

$(document).ready(function(){
    app.pagearticleController.defaultAction.init();
});
